export default "__VITE_ASSET__BiZh4pMa__"